import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DashboardFilterBridgeComponent } from './dashboard-filter-bridge.component';
import { DashboardSiteSelectorBridgeComponent } from './dashboard-site-selector-bridge.component';

@NgModule({
  imports: [CommonModule],
  declarations: [DashboardFilterBridgeComponent, DashboardSiteSelectorBridgeComponent],
  exports: [DashboardFilterBridgeComponent, DashboardSiteSelectorBridgeComponent],
})
export class FilterPanelModule {}
